export const previewTableConsts = {
    MODAL_WIDTH: "70rem",
    MODAL_TITLE: "Invoice Preview",
    DOCUMENT_CLASS: "documentStyle",
    PAGE_CLASS: "pageStyle",
    ERROR_MESSAGE: "Unable to load pdf",
    LOADING_MESSAGE: "Loading...",
    BASE_SCALE: 1,
};
